import React, { useState, useEffect } from "react";
import api from "../../api";

const UnpaidStudentsPage = () => {
    const [classes, setClasses] = useState([]);
    const [classId, setClassId] = useState("");
    const [month, setMonth] = useState("");
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);

    // ✅ Load Classes
    useEffect(() => {
        const fetchClasses = async () => {
            try {
                const res = await api.get("/get-classes");
                if (res.data && res.data.success) {
                    setClasses(res.data.data);
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchClasses();
    }, []);

    // ✅ Fetch Unpaid List
    const fetchData = async () => {
        if (!classId || !month) {
            alert("Select class & month");
            return;
        }

        setLoading(true);
        try {
            const res = await api.get(
                `/fee-unpaid/unpaid_list?class_id=${classId}&month=${month}`
            );
            setStudents(res.data.data || []);
        } catch (err) {
            console.error(err);
            setStudents([]);
        }
        setLoading(false);
    };

    return (
        <div style={{ padding: 30, maxWidth: 1100, margin: "auto" }}>

            {/* FILTER SECTION */}
            <section style={cardStyle}>
                <h2 style={titleStyle}>🎯 Filter Students</h2>

                <div style={filterGrid}>
                    {/* Class */}
                    <div>
                        <label>Class</label>
                        <select
                            value={classId}
                            onChange={(e) => setClassId(e.target.value)}
                            style={inputStyle}
                        >
                            <option value="">Select Class</option>
                            {classes.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.class_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Month */}
                    <div>
                        <label>Month</label>
                        <select
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            style={inputStyle}
                        >
                            <option value="">Select Month</option>
                            {Array.from({ length: 12 }, (_, i) => {
                                const m = String(i + 1).padStart(2, "0");
                                return (
                                    <option key={m} value={m}>
                                        {new Date(0, i).toLocaleString("default", {
                                            month: "long",
                                        })}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    {/* Button */}
                    <div style={{ alignSelf: "flex-end" }}>
                        <button style={buttonStyle} onClick={fetchData}>
                            Search
                        </button>
                    </div>
                </div>
            </section>

            {/* TABLE */}
            <section style={cardStyle}>
                <h2 style={titleStyle}>📋 Unpaid Students</h2>

                {loading ? (
                    <p>Loading...</p>
                ) : students.length === 0 ? (
                    <p>No unpaid students found.</p>
                ) : (
                    <div style={{ overflowX: "auto" }}>
                        <table style={tableStyle}>
                            <thead style={{ textAlign: "left" }}>
                                <tr>
                                    <th style={thStyle}>#</th>
                                    <th style={thStyle}>Student Code</th>
                                    <th style={thStyle}>Name</th>
                                    <th style={thStyle}>Mobile</th>
                                    <th style={thStyle}>Class</th>
                                    <th style={thStyle}>Fee Type</th>
                                    <th style={thStyle}>Amount</th>
                                </tr>
                            </thead>

                            <tbody>
                                {students.map((s, i) => (
                                    <tr key={s.id} style={i % 2 ? trOdd : trEven}>
                                        <td style={tdStyle}>{i + 1}</td>
                                        <td style={tdStyle}>{s.student_code}</td>
                                        <td style={tdStyle}>{s.name}</td>
                                        <td style={tdStyle}>{s.mobile}</td>
                                        <td style={tdStyle}>{s.class_name}</td>
                                        <td style={tdStyle}>{s.fee_type}</td>
                                        <td style={tdStyle}>₹ {s.amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                )}
            </section>
        </div>
    );
};

export default UnpaidStudentsPage;

/* ===== STYLES ===== */

const cardStyle = {
    background: "#fff",
    padding: 25,
    borderRadius: 12,
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    marginBottom: 30,
};

const titleStyle = {
    color: "#0077cc",
    marginBottom: 20,
};

const filterGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 150px",
    gap: 20,
};

const inputStyle = {
    width: "100%",
    padding: 10,
    borderRadius: 6,
    border: "1px solid #ccc",
};

const buttonStyle = {
    padding: "10px 20px",
    background: "#0077cc",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "left",
};

const thStyle = {
    padding: 12,
    background: "#0077cc",
    color: "#fff",
    textAlign: "left",
    fontWeight: 600,
    verticalAlign: "middle",
};

const tdStyle = {
    padding: 12,
    borderBottom: "1px solid #e5e7eb",
    textAlign: "left",
    verticalAlign: "middle",
};


const trEven = { background: "#f9fafb" };
const trOdd = { background: "#eef3f9" };
